import { gql } from '@apollo/client';

export const INFORMATION_CREATE = gql`
    mutation informationCreate($input: InformationInput!) {
        informationCreate(input: $input) {
            information {
                id
            }
        }
    }
`;

export const INFORMATION_UPDATE = gql`
    mutation informationUpdate($information: ID!, $input: InformationUpdateInput!) {
        informationUpdate(information: $information, input: $input) {
            information {
                id
            }
        }
    }
`;

export const INFORMATION_DELETE = gql`
    mutation informationDelete($information: ID!) {
        informationDelete(information: $information) {
            success
        }
    }
`;
